(() => {
  const roots = document.querySelectorAll('[data-pmc]');
  if (!roots.length) return;

  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const header = document.querySelector('.shopify-section-group-header-group') || document.querySelector('header,[data-section-type="header"]');

  const findScroller = (element) => {
    let parent = element.parentElement;
    while (parent && parent !== document.body) {
      const style = getComputedStyle(parent);
      if (/(auto|scroll|overlay)/.test(style.overflowY) && parent.scrollHeight > parent.clientHeight + 1) return parent;
      parent = parent.parentElement;
    }
    return window;
  };

  const scroller = findScroller(roots[0]);
  let headerHeight = 72;
  let ticking = false;

  const measureHeader = () => {
    if (!header) return;
    const headerRect = header.getBoundingClientRect();
    const scrollerTop = scroller === window ? 0 : Math.max(0, scroller.getBoundingClientRect().top);
    headerHeight = Math.max(0, Math.ceil(Math.max(headerRect.height, scrollerTop)));
  };

  const setOffsets = () => {
    const headerBottom = header ? Math.max(0, Math.min(innerHeight, header.getBoundingClientRect().bottom)) : 0;
    const scrollerTop = scroller === window ? 0 : Math.max(0, scroller.getBoundingClientRect().top);
    const stickyOffset = Math.max(0, Math.ceil(headerBottom - scrollerTop));
    roots.forEach((root) => {
      root.style.setProperty('--pmc-header-offset', `${stickyOffset}px`);
      root.style.setProperty('--pmc-header-height', `${headerHeight}px`);
    });
    ticking = false;
  };

  const queueOffsets = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(setOffsets);
  };

  measureHeader();
  setOffsets();
  addEventListener('resize', () => {
    measureHeader();
    queueOffsets();
  });
  (scroller === window ? window : scroller).addEventListener('scroll', queueOffsets, { passive: true });
  if (header && 'ResizeObserver' in window) {
    new ResizeObserver(() => {
      measureHeader();
      queueOffsets();
    }).observe(header);
  }

  roots.forEach((root) => {
    root.classList.add('js');

    if (!reduced && 'IntersectionObserver' in window) {
      const revealObserver = new IntersectionObserver((entries) => entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      }), { threshold: 0.08, rootMargin: '0px 0px -8%' });
      root.querySelectorAll('.pmc-reveal').forEach((element) => revealObserver.observe(element));
    } else {
      root.querySelectorAll('.pmc-reveal').forEach((element) => element.classList.add('is-visible'));
    }

    root.querySelectorAll('[data-pmc-story]').forEach((story) => {
      const steps = [...story.querySelectorAll('.pmc-step')];
      const frames = [...story.querySelectorAll('.pmc-story__frame')];
      const activate = (index) => {
        steps.forEach((step, current) => step.classList.toggle('is-active', current === index));
        frames.forEach((frame, current) => frame.classList.toggle('is-active', current === index));
      };
      activate(0);
      if (!reduced && 'IntersectionObserver' in window) {
        const storyObserver = new IntersectionObserver((entries) => {
          const visible = entries.filter((entry) => entry.isIntersecting).sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
          if (visible) activate(steps.indexOf(visible.target));
        }, { threshold: [0.3, 0.5, 0.7], rootMargin: '-42% 0px -42%' });
        steps.forEach((step) => storyObserver.observe(step));
      }
    });

    const gates = [...root.querySelectorAll('[data-pmc-gate]')];
    const targets = [...root.querySelectorAll('[data-pmc-gate-target]')];
    if (gates.length && targets.length && 'IntersectionObserver' in window) {
      const gateObserver = new IntersectionObserver((entries) => {
        const visible = entries.find((entry) => entry.isIntersecting);
        if (!visible) return;
        const id = visible.target.dataset.pmcGateTarget;
        gates.forEach((gate) => gate.classList.toggle('is-active', gate.dataset.pmcGate === id));
      }, { threshold: 0.2, rootMargin: '-38% 0px -48%' });
      targets.forEach((target) => gateObserver.observe(target));
    }
  });
})();
